module.exports = __webpack_public_path__ + "static/media/reset-check.fa01a53d.svg";